/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:70ad44f0-38f6-4b2b-9edf-b4e81a7ccb39",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vIUlaJMsZ",
    "aws_user_pools_web_client_id": "3mf0es06tf79k2t5528vet8e6f",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "api4df5e677",
            "endpoint": "https://rskrhasxw1.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "apicustomers",
            "endpoint": "https://zyxzbucovg.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "apic48d2c9b",
            "endpoint": "https://jee0rewmv2.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "doveUsers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "doveInvites-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "doveCustomers-dev",
            "region": "us-east-1"
        },
        {
            "tableName": "doveSwitches-dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
